import SuperagentApi from '../assets/utils/superagent'

const modelSetting = Wiz.globalSettings?.globalConfig?.modelSetting || {}
export default class EngineNodeService {
  static async getFreeEngineId(payload) {
    const superagentApi = new SuperagentApi({ baseUrl: modelSetting.engineNodeServer })
    const [err, res] = await superagentApi.get('/api/cloud-render-node/distribute-node', {
      params: { ...payload },
    })
    return [err, res]
  }
}
